import { Injectable } from '@angular/core';
import { HttpClient,HttpParams,HttpHeaders } from  '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import {Role} from '../interface/role';

@Injectable({
  providedIn: 'root'
})
export class RoleService {
  httpOptions:any;
  headers:any;

  private _refreshNeeded$ = new Subject<void>();

  get refreshNeeded$() {
    return this._refreshNeeded$;
  }

  constructor(private http:HttpClient) 
    {
      this.httpOptions = {
        headers: new HttpHeaders({
          'Content-Type':  'application/json',
          'Authorization': 'my-auth-token'
        })
      };
    }

  getAllRole(url){
      return this.http.get(url,this.httpOptions)
  }

   postRole(url,param){
  return this.http.post<Role>(url,param,this.httpOptions)
  .pipe(
    tap(() =>  {
      this._refreshNeeded$.next();
    })
  );
}
}
